import { useEffect, useRef } from 'react';
function useRecursiveTimeout(callback, delay) {
    const savedCallback = useRef(callback);
    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the timeout loop.
    useEffect(() => {
        let id;
        let cancel = false;
        function tick() {
            const ret = savedCallback.current();
            if (ret instanceof Promise) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                ret.then(() => {
                    if (delay !== null && !cancel) {
                        id = window.setTimeout(tick, delay);
                    }
                });
            }
            else if (delay !== null && !cancel) {
                id = window.setTimeout(tick, delay);
            }
        }
        if (delay !== null) {
            id = window.setTimeout(tick, delay);
            return () => {
                if (id) {
                    window.clearTimeout(id);
                }
                cancel = true;
            };
        }
    }, [delay]);
}
export default useRecursiveTimeout;
